module.exports = __webpack_public_path__ + "5b389344f18dd43e9e072ce55aac4af9.svg";